module.exports = __webpack_public_path__ + "preview-eac7acfc/ibm-plex-sans-bold-abbf272a9e54ea64306892861d5714a8.woff";